module.exports = __webpack_public_path__ + "img/Margarita.ffe40dd8.png";